<template>
	<v-card>
		<div class="app-dialog-container new-dialogs-wrap">
			<v-dialog
				v-model="isOpen"
				v-bind="$attrs"
				v-on="$listeners"
				:contentClass="_contentClass"
				@click:outside="closeCurrentDialog"
				@keydown.esc="closeCurrentDialog"
				overlay-opacity="0.7"
				overlay-color="#80899C"
				:persistent="disableClose"
			>
				<div class="app-dialog-content" :class="{ 'overflow-hidden': overflowHidden }">
					<div v-if="!!$slots.header" class="dialog-header display-flex"><slot name="header"></slot></div>
					<AppCloseX
						v-if="!disableClose && !hideCloseButton"
						class="app-close-x-container"
						:style="`right: ${closeRight || 10}px; top: ${closeTop || 10}px;`"
						@onClose="closeCurrentDialog"
					/>
					<slot />
				</div>
			</v-dialog>
		</div>
	</v-card>
</template>

<script>
import RouterService from '@/router/router-service';
import IframeService from '@/utils/iframe-service';
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';
export default {
	name: 'AppDialog',
	props: {
		closeRight: { type: String },
		contentClass: { type: String },
		disableClose: { type: Boolean },
		overflowHidden: { type: Boolean },
		hideCloseButton: { type: Boolean },
		disableMaxWidth: { type: Boolean },
		closeTop: { type: [String, Number] },
		transparentBackground: { type: Boolean },
		showShadow: { type: Boolean, default: true },
		layoutMode: { type: Boolean, default: false },
	},
	computed: {
		_contentClass() {
			const classes = [
				'app-dialog',
				'new-dialogs-wrap',
				this.showShadow ? '' : 'no-shadow',
				this.isLoadedFromExtension ? 'overflow-y-auto overflow-x-hidden' : '',
			];
			if (this.disableMaxWidth) {
				classes.push('disable-max-width');
			}
			if (this.transparentBackground) {
				classes.push('transparent-background');
			}
			if (this.contentClass) {
				classes.push(this.contentClass);
			}
			return classes.join(' ');
		},
		isLoadedFromExtension() {
			return RouterService.isLoadedFromExtension(this.$route);
		},
	},
	methods: {
		closeCurrentDialog() {
			if (this.disableClose) {
				return;
			}
			this.$emit('onCancel');
			if (!this.layoutMode) {
				AppDialogManagerService.closeCurrentDialog();
				if (this.isLoadedFromExtension) {
					IframeService.sendMessageToParent({ action: 'closeDialogClicked' });
				}
			}
		},
	},
	data() {
		return {
			isOpen: true,
		};
	},
};
</script>

<style scoped lang="scss">
::v-deep {
	.app-dialog {
		overflow-y: scroll;

		&.new-dialogs-wrap {
			$side-pad: 30px;

			background-color: var(--app-dialog-bg);
			color: var(--primary-font-color);
			&:not(.disable-max-width) {
				max-width: 640px;
			}

			&.transparent-background {
				background-color: unset !important;
				background-color: transparent !important;
			}

			&.no-shadow {
				box-shadow: none !important;
			}

			.app-dialog-content {
				&.overflow-hidden {
					overflow: hidden;
				}
				position: relative;
			}

			&.v-dialog {
				border-radius: 10px;
				overflow-y: inherit; // so dropdowns can extend beyond the dialog (e.g. ShareModuleDialog)
				margin: 0px !important;
			}
			&.v-dialog:not(.v-dialog--fullscreen) {
				max-height: 100% !important;
			}

			.dialog-header {
				height: 46px;
				padding: 0 $side-pad;
				border-bottom: var(--primary-border);
			}
			.dialog-title {
				padding: 20px $side-pad 10px $side-pad;
				font-size: 20px;
				font-weight: 700;
			}

			.dialog-description {
				padding: 5px $side-pad;
				font-size: 14px;
				font-weight: 400;
			}

			.dialog-body {
				padding: 0 $side-pad;
				font-size: 12px;
			}

			.dialog-bottom {
				padding: 20px $side-pad;
			}

			.app-close-x-container {
				position: absolute;
				top: 10px;
				right: 10px;
				z-index: 1;
			}
		}
	}
}
</style>
